import { fmtEur } from 'sotcp-core/dayUtils'

export { fmtEur }
export { todayIso, addDays, formatDate, formatMedium, formatShort, timeAgo } from 'sotcp-core/dayUtils'

const HEURE = new Intl.DateTimeFormat('fr-FR', {
  hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris',
})
const HEURE_S = new Intl.DateTimeFormat('fr-FR', {
  hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Europe/Paris',
})

export const heure = (iso: string | null | undefined): string =>
  iso ? HEURE.format(new Date(iso)) : '—'

export const heureSec = (iso: string | null | undefined): string =>
  iso ? HEURE_S.format(new Date(iso)) : '—'

/** Chrono discret : 1:04:32 au-delà de l'heure, 04:32 en dessous. */
export function duree(secondes: number): string {
  const s = Math.max(0, Math.floor(secondes))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const r = s % 60
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`
    : `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`
}

/** « il y a 12 min », pour la reprise après interruption. */
export function depuis(ms: number): string {
  const min = Math.floor(ms / 60000)
  if (min < 60) return `${min} min`
  const h = Math.floor(min / 60)
  const r = min % 60
  return r ? `${h} h ${String(r).padStart(2, '0')}` : `${h} h`
}

export function initiales(nom: string | null | undefined): string {
  if (!nom) return '??'
  const mots = nom.trim().split(/[\s@.]+/).filter(Boolean)
  if (mots.length === 0) return '??'
  if (mots.length === 1) return (mots[0] ?? '').slice(0, 2).toUpperCase()
  return ((mots[0] ?? '')[0] ?? '' ).toUpperCase() + ((mots[1] ?? '')[0] ?? '').toUpperCase()
}

/** Un nombre de fichiers, de tickets… au pluriel correct sans y penser. */
export const pluriel = (n: number, singulier: string, plur = singulier + 's'): string =>
  `${n} ${n > 1 ? plur : singulier}`
